<div class="header-bar">
  <h1>Organisation Task Types</h1>
</div>
<div class="content-container">
  <form (ngSubmit)="search()" style="width: 100%">
    <div class="ui-g filterPanel">
      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <input name="name" type="text" pInputText [(ngModel)]="filter.filters.name.value" />
          <label>Name</label>
        </span>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <span class="md-inputfield filterItem">
          <p-dropdown
            name="organisationType"
            placeholder="Organisation Type"
            [showClear]="true"
            [options]="organisationTypeOpts"
            [(ngModel)]="filter.filters.organisationType.value"
          ></p-dropdown>
        </span>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-2">
        <button pButton type="submit" label="Search"></button>
        <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
      </div>
    </div>
  </form>

  <p-table
    #dt
    selectionMode="single"
    [value]="page.items"
    [lazy]="true"
    [rows]="filter.rows"
    [responsive]="true"
    [first]="filter.first"
    [paginator]="true"
    [rowHover]="true"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [pageLinks]="5"
    [totalRecords]="page.total"
    (onLazyLoad)="onGridLazyLoad($event)"
    [sortField]="filter.sortField"
    [sortOrder]="filter.sortOrder"
    [loading]="isLoading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Type</th>
        <th *ngFor="let col of taskTypesColumns">{{ col.header }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item">
        <td>{{ item.name }}</td>
        <td>
          <div [title]="getOrgTypeName(item.organisationType)">
            {{ getOrgTypeName(item.organisationType) }}
          </div>
        </td>
        <td *ngFor="let col of taskTypesColumns">
          <div style="text-align: center">
            <p-checkbox
              [ngModel]="item[col.field]"
              binary="true"
              (onChange)="onTaskTypeCheckboxChange($event, item, col.field)"
            ></p-checkbox>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- DATATABLE DEPRECATED --
  <p-dataTabl #dt selectionMode="single" [value]="page.items" [lazy]="true" [rows]="filter.rows" [responsive]="true" [first]="filter.first"
               [paginator]="true" [rowHover]="true" [rowsPerPageOptions]="[10,20,50,100]" [pageLinks]="5" [totalRecords]="page.total"
               (onLazyLoad)="onGridLazyLoad($event)" [sortField]="filter.sortField" [sortOrder]="filter.sortOrder"
               [loading]="isLoading">
      <p-column field="name" header="Name" [sortable]="true" [editable]="false">
          <ng-template let-data="rowData" pTemplate="body">
              <div [title]="data.name">{{data.name}}</div>
          </ng-template>
      </p-column>
      <p-column field="organisationType" header="Type" [sortable]="true" [editable]="false">
          <ng-template let-data="rowData" pTemplate="body">
              <div [title]="getOrgTypeName(data.organisationType)">{{getOrgTypeName(data.organisationType)}}</div>
          </ng-template>
      </p-column>
      <p-column *ngFor="let col of taskTypesColumns" [field]="col.field" [header]="col.header">
          <ng-template let-data="rowData" pTemplate="body">
              <div style="text-align: center;">
                  <p-checkbox  [ngModel]="data[col.field]" binary="true"  (onChange)="onTaskTypeCheckboxChange($event, data, col.field)"></p-checkbox>
              </div>
          </ng-template>
      </p-column>
  </p-dataTable>

  --->

  <div class="footerPanel ui-grid-row">
    <button
      class="btn-to-right"
      type="button"
      (click)="save()"
      label="Save"
      [disabled]="!saveEnabled"
      pButton
      icon="fa ui-icon-check"
    ></button>
  </div>
</div>

<div class="ui-g-12" *ngIf="invalidTaskTypes && invalidTaskTypes.length > 0">
  <div class="card card-w-title">
    <h1>The following task type assignments are invalid and cannot be saved</h1>
    <h3>
      (ensure the selected task types have a corresponding service type agreement for the
      organisation)
    </h3>
    <div *ngFor="let typeInfo of invalidTaskTypes">
      {{ typeInfo.name }}
      <ul>
        <li *ngFor="let taskType of typeInfo.taskTypes">{{ taskType }}</li>
      </ul>
    </div>
  </div>
</div>
